import {Grid, Menu, Icon} from "semantic-ui-react";
import React from "react";
import marked from 'marked';

const NotificationBar = ({notificationText, updateIsNotificationBarShown}) => {
	const getHtmlObject = (text) => {
		const tokens = marked.lexer(text);
		return {
			__html: marked.parser(tokens)
		};
	};

	return (
		<Menu id="site-notification-bar" inverted borderless size="mini" fixed="bottom"
					style={{background: '#ffe053', zIndex: '999999'}}>

			<Grid stackable style={{width: '100%', margin: 0, padding: 0}}>
				<Grid.Row style={{margin: '5px 0px', padding: 0}}>
					<Grid.Column width={15} style={{textAlign: 'center'}}>
						<div
							dangerouslySetInnerHTML={getHtmlObject(notificationText)}
							style={{fontSize: '15px'}}
						/>
					</Grid.Column>
					<Grid.Column width={1} style={{textAlign: 'right', marginTop: '2px'}}>
						<Icon
							id="site-notification-bar-close-btn"
							name="close"
							size='large'
							onClick={() => updateIsNotificationBarShown(false)}
							style={{cursor: 'pointer'}}
						/>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		</Menu>
	);
};

export default NotificationBar;
